import { Duration } from "luxon";

export const toLocaleHours = (ms: number) => {
  return Duration.fromMillis(ms).toFormat("h:mm");
};
